module.exports = __webpack_public_path__ + "static/img/pc-web-img-01@m.94809c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/d-steady/pc-web-img-01@m.png
// module id = aJd1
// module chunks = 0